import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class MessagingSettings {

    /**
     * Retrieves the authentication settings/configurations from the given project.
     * @param {number} project_id The project ID, from where the configurations should be loaded.
     */
    static async load(project_id){
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/messaging_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Saves the messaging settings in the backend.
     * @param {int} project_id The project id, where the configuration should be saved.
     * @param {string} fcm_server_key The new Firebase Cloud Messaging server key.
     */
    static async save(project_id, fcm_server_key) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/messaging_settings/",
                method: "PUT",
                data: {
                    _console_token: UserSession.token,
                    project: project_id,
                    fcm_server_key: fcm_server_key
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Loads all the open requests, which will be send to FCM.
     * @param {int} project_id The project id, where the requests are located.
     */
    static async getOpenRequests(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/messaging_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "get_open_requests"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }

    /**
     * Loads all the sent requests, which will be send to FCM.
     * @param {int} project_id The project id, where the requests are located.
     */
    static async getSentRequests(project_id) {
        return new Promise((resolve) => {
            axios({
                url: Vars.API_ENDPOINT + "/console_api/v1/messaging_settings/",
                method: "GET",
                params: {
                    _console_token: UserSession.token,
                    project: project_id,
                    function: "get_sent_requests"
                }
            }).then(function(data){
                resolve(data.data);
            });
        });
    }
}